import { isValidEmail } from 'components/Shared/Form/rules';
import { postSubscribe } from 'services/ApiNewsletterService';
import { SideEffect } from 'components/Shared/connect';
import { handleServerError } from 'components/Shared/server/request';

export const NEWSLETTER_SUBSCRIBE = 'NEWSLETTER_SUBSCRIBE';
export const NEWSLETTER_SUBSCRIBE_SUCCESS = 'NEWSLETTER_SUBSCRIBE_SUCCESS';
export const NEWSLETTER_CLOSE_MODAL = 'NEWSLETTER_CLOSE_MODAL';
export const NEWSLETTER_SET_EMAIL = 'NEWSLETTER_SET_EMAIL';
export const NEWSLETTER_SHOW_EMAIL_INVALID = 'NEWSLETTER_SHOW_EMAIL_INVALID';
export const CCC_MARKETING_CONSENT = 'CCC_MARKETING_CONSENT';

export const newsletterSubscribe = () => ({
  type: NEWSLETTER_SUBSCRIBE
});

export const newsletterSubscribeSuccess = () => ({
  type: NEWSLETTER_SUBSCRIBE_SUCCESS
});

export const closeNewsletterModal = () => ({
  type: NEWSLETTER_CLOSE_MODAL
});

export const setNewsletterEmail = (email: string) => ({
  type: NEWSLETTER_SET_EMAIL,
  payload: { email, valid: isValidEmail(email) }
});

export const showEmailInvalidError = () => ({
  type: NEWSLETTER_SHOW_EMAIL_INVALID
});

export const subscribeToNewsletter =
  (email: string): SideEffect =>
  dispatch => {
    if (!isValidEmail(email)) {
      dispatch(showEmailInvalidError());
      return Promise.resolve();
    }
    dispatch(newsletterSubscribe());
    return postSubscribe(email)
      .then(() => dispatch(newsletterSubscribeSuccess()))
      .catch(handleServerError(dispatch));
  };
